<template>
  <div class="contaier overflow-hidden">
    <div class="top-nvb_box">
      <div class="top-nvb flex flex-col sm:flex-row sm:justify-center items-center pt-[15px] pb-[15px] sm:py-[20px]">
        <div class="logo-box">
          <img alt="" class="img" src="./assets/img/logo.png" />
        </div>
      </div>
    </div>
    <div
      class="top-banner h-[80vh] sm:h-[105vh] md:h-[700px] lg:h-[95vh] xl:h-[100vh] mt-[50px] sm:mt-[61px] relative overflow-hidden"
      id="section-banner"
    >
      <!-- <div
        class="absolute top-[3rem] pr-[1rem] lg:top-[10%] left-[5%] lg:left-[7%] xl:left-[10%] text-[1.4rem] lg:text-[1.6rem] xl:text-[1.8rem] font-bold"
      ></div> -->
      <picture class="picture" style="">
        <source srcset="https://img.kamlung.net/v23AI/icaur_kv.jpg" media="(min-width: 768px)" />
        <source srcset="https://img.kamlung.net/v23AI/icaur_kv_2.jpg" media="(max-width: 769px)" />
        <img class="md:h-full" src="https://img.kamlung.net/v23AI/icaur_kv.jpg" loading="lazy" alt="" />
      </picture>
      <div
        class="max-w-[100%] sx:w-[450px] sm:w-[480px] absolute bottom-0 right-0 py-2 px-3 xs:py-3 xs:px-4 text-[#111] bg-[rgba(255,255,255,0.9)] flex flex-row items-center justify-between"
      >
        <div class="text-[12px] sm:text-[13px] mr-[10px] sx:mr-[4px] md:mr-[6px]">特別鳴謝：</div>
        <div class="h-[15px] sx:h-[20px] sm:h-[23px] mr-[10px] sx:mr-[4px] md:mr-[6px]">
          <img src="./assets/img/sponsorship/1.png" class="h-full !w-auto" />
        </div>
        <div class="h-[16px] sx:h-[23px] sm:h-[25px]">
          <img src="./assets/img/sponsorship/2.png" class="h-full !w-auto" />
        </div>
      </div>
    </div>
    <nav-bar :items="navItems" />

    <!-- 首次访问弹窗 -->
    <!-- <div v-if="showPopup" class="popup-overlay" @click.self="showPopup = false">
      <div class="popup-card">
        <button class="popup-card__close" @click="closePopup">&times;</button>
        <h2 class="popup-card__title">
          最後加場召集！
          <br />
          iCAUR x 騰訊混元 3D
          <br />
          AI 線上培訓工作坊
        </h2>
        <p class="popup-card__subtitle">工作坊費用全免，立即報名！</p>
        <div class="popup-card__section">
          <h3 class="popup-card__section-title">線上工作坊詳情：</h3>
          <p class="popup-card__info">
            <span class="popup-card__label">日期：</span>
            2026年8月3日（星期一）
          </p>
          <p class="popup-card__info">
            <span class="popup-card__label">時間：</span>
            15:30 – 17:00
          </p>
          <p class="popup-card__info">
            <span class="popup-card__label">形式：</span>
            線上進行（互動教學、即時 Q&A）
          </p>
          <p class="popup-card__note">(備註：若報名人數未滿 100 位，將改為錄播形式進行)</p>
          <p class="popup-card__info">
            <span class="popup-card__label">內容：</span>
            示範 AI 生成汽車多角度概念圖、一鍵轉專業 3D 模型
          </p>
        </div>
        <button class="popup-card__btn" @click="popupRegister('formContainer')">馬上報名</button>
      </div>
    </div> -->
    <div v-if="showPopup" class="popup-overlay" @click.self="showPopup = false">
      <div class="popup-card">
        <button class="popup-card__close" @click="closePopup">&times;</button>
        <h2 class="popup-card__title !text-[#000]">
          方盒玩家・玩創未來
          <br />
          【騰訊混元3D AI 教學影片】
        </h2>
        <!-- <p class="popup-card__subtitle">工作坊費用全免，立即報名！</p> -->
        <!-- <div class="popup-card__section">
          <h3 class="popup-card__section-title">下载 騰訊混元3DAI教學影片</h3>
        </div> -->
        <button class="popup-card__btn mt-6" @click="popupRegister2()">下載教學影片</button>
      </div>
    </div>

    <!-- 賽事引言 -->
    <div class="max-w-[1200px] w-[92%] m-auto py-[80px] md:pt-[320px] md:pb-[200px] overflow-hidden">
      <div class="text-[30px] lg:text-[36px] font-bold text-center pb-[45px] md:pb-[55px] text-[#000]">
        <!-- 賽事引言 -->
        <img src="./assets/img/1111.png" class="w-[320px] md:w-[460px] m-auto z-10 relative" />
      </div>
      <div
        class="text-center text-[#111] font-bold text-[18px] leading-[36px] md:text-[24px] md:leading-[50px] max-w-[636px] w-full px-4 m-auto relative diagonal-line-container"
      >
        敢衝破束縛，方顯玩家本色。
        <br />
        秉承「BORN TO PLAY」理念，
        <br />
        迎合舒適都市出行，更能真正能攀山涉水越野的純電車！
        <br />
        iCAUR 召集全港創意高手一較高下。
        <br />
        玩轉方盒，釋放靈感！
        <br />
        運用 AI 打造專屬風格。
      </div>
    </div>

    <!-- 比賽宗旨 -->
    <div class="max-w-[1200px] w-[92%] m-auto py-[80px] md:pt-[320px] md:pb-[60px] overflow-hidden">
      <div
        class="max-w-[1200px] w-[90%] m-auto mt-[20px] md:mt-[40px] mb-[40px] md:mb-[70px] rounded-2xl p-5 md:p-10 md:py-[70px] text-[#111] relative overflow-hidden"
        style="
          background: rgba(255, 255, 255, 0.6);
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          border: 1px solid rgba(255, 255, 255, 0.6);
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04);
        "
      >
        <div class="text-[30px] lg:text-[36px] font-bold text-center pb-[45px] md:pb-[55px] text-[#000]">
          <!-- 比賽宗旨 -->
          <img src="./assets/img/1111-2.png" class="w-[320px] md:w-[460px] m-auto z-10 relative" />
        </div>
        <!-- 左上角装饰条 -->
        <div class="absolute top-0 left-0 w-[60px] md:w-[100px] h-[4px] bg-[#f15108] rounded-bl-lg"></div>
        <!-- 右下角装饰条 -->
        <div class="absolute bottom-0 right-0 w-[60px] md:w-[100px] h-[4px] bg-[#f15108] rounded-tr-lg"></div>
        <p class="text-[14px] md:text-[16px] lg:text-[18px] leading-7 md:leading-10 mb-8">
          奇瑞汽車（CHERY AUTO）旗下新能源品牌 iCAUR 2026 年正式登錄香港。首次與騰訊（TENCENT）合作為官方 AI
          合作夥伴，今年夏天舉辦一項設計盛事「全港 iCAUR V23 AI 汽車設計比賽」，適合學生及公開組不同界別人士參與。
        </p>
        <p class="text-[14px] md:text-[16px] lg:text-[18px] leading-7 md:leading-10 mb-8">
          本次活動旨在推動由最新 AI
          技術賦能並釋放個人設計創意，為香港學生、設計師以至廣大車迷，搭建一個直接與中國汽車製造商溝通認識的平臺，展示個人風格與潛力，探索潛在的職業發展機遇。勝出者可前往參觀
          2026 年奇瑞全球品牌大會（預計 10 月）及參觀奇瑞汽車最新的 AI
          智能生產工廠。勝出設計作品更有機會在真實市場中展出及投入商業化生產。
        </p>
        <p class="text-[14px] md:text-[16px] lg:text-[18px] leading-7 md:leading-10">
          大賽將於 2026 年 6 月 18 日至 22 日在亞洲國際博覽館舉行的「2026
          年香港國際汽車及供應鏈博覽會」媒體發布會上正式宣佈啟動。
        </p>
      </div>
    </div>

    <!-- 參賽組別 -->
    <div class="max-w-[1200px] w-[92%] m-auto py-[80px] md:pt-[320px] md:pb-[200px]">
      <div class="text-[30px] lg:text-[36px] font-bold text-center pb-[45px] md:pb-[55px] text-[#000]">
        <!-- 賽事引言 -->
        <img src="./assets/img/1111-3.png" class="w-[320px] md:w-[460px] m-auto z-10 relative" />
      </div>
      <div class="md:w-full xl:w-[92%] flex flex-col">
        <div
          class="md:w-full xl:w-[94%] flex flex-col md:flex-row gap-[0] md:gap-[30px] xl:gap-[80px] items-center m-auto"
        >
          <div class="w-[90%] md:w-full xl:w-[500px] mb-8 md:mb-0">
            <img src="https://img.kamlung.net/v23AI/group1.jpg" class="w-full" />
          </div>
          <div class="w-[90%] md:w-full xl:w-[500px] mb-8 md:mb-0">
            <img src="https://img.kamlung.net/v23AI/group2.jpg" class="w-full" />
          </div>
        </div>
        <div class="md:w-full xl:w-[94%] m-auto md:mt-[30px] xl:mt-[60px]">
          <!-- <img src="./assets/img/group3.jpg" class="md:w-full" /> -->
          <div class="p-2 text-center text-[22px] md:text-[26px] bg-[#f2f1f1]">
            * 參賽者只能選擇
            <strong class="text-[#ef6b02]">參加一個組別</strong>
          </div>
        </div>
      </div>
    </div>

    <!-- 賽事進程 -->
    <div class="w-[100%]" id="section-process">
      <div class="max-w-[1460px] w-[98%] m-auto py-[60px] md:py-[120px]">
        <div class="text-[30px] lg:text-[36px] font-bold text-center pb-[45px] md:pb-[55px] text-[#000]">
          <!-- 賽事進程 -->
          <img src="./assets/img/3333.png" class="w-[320px] md:w-[460px] m-auto z-10 relative" />
        </div>
        <!-- <div>
          <picture>
            <source srcset="./assets/img/Timeline.png" class="w-full" media="(min-width: 799px)" />
            <source srcset="./assets/img/Timeline2.jpg" class="w-full" media="(max-width: 800px)" />
            <img src="./assets/img/Timeline.png" class="w-full" loading="lazy" alt="" />
          </picture>
        </div> -->

        <!-- ========== 手机端垂直时间线 ========== -->
        <div class="mobile-timeline md:hidden">
          <div v-for="(group, gIdx) in processGroups" :key="'mg-' + gIdx" class="mobile-group">
            <h3 class="mobile-group__title">{{ group.title }}</h3>
            <div class="mobile-steps">
              <div v-for="(step, sIdx) in group.steps" :key="'ms-' + sIdx" class="mobile-step">
                <!-- 左侧：编号 + 图标 + 竖线 -->
                <div class="mobile-step__left">
                  <div class="mobile-step__num">
                    <span>{{ step.num }}</span>
                  </div>
                  <div class="mobile-step__icon">
                    <img :src="step.icon" alt="" />
                  </div>
                </div>
                <!-- 右侧：标题 + 时间 + 内容 -->
                <div class="mobile-step__right">
                  <div class="mobile-step__title relative">
                    {{ step.title }}
                    <div v-if="sIdx == 0" class="text-[12px] bottom-[-7px] absolute">（可自由參加）</div>
                  </div>
                  <div class="mobile-step__time-row">
                    <span class="mobile-step__label" v-html="clockIcon"></span>
                    <span class="mobile-step__label-text">日期</span>
                  </div>
                  <div class="mobile-step__time" v-html="step.time"></div>
                  <div class="mobile-step__content-row">
                    <span class="mobile-step__label" v-html="docIcon"></span>
                    <span class="mobile-step__label-text">內容</span>
                  </div>
                  <div class="mobile-step__content" v-html="step.content"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ========== 桌面端时间线 ========== -->
        <div class="process-timeline max-w-[1400px] w-[98%] m-auto hidden md:block">
          <!-- 两大分组 -->
          <div v-for="(group, gIdx) in processGroups" :key="'pg-' + gIdx" class="process-group">
            <!-- 分组大标题 -->
            <!-- <h3 class="process-group__title">{{ group.title }}</h3> -->

            <div class="process-group__body">
              <!-- 阶段间箭头 -->
              <div class="process-arrows">
                <span
                  class="process-arrow md:w-[35px] md:h-[35px] lg:w-[50px] lg:h-[50px]"
                  v-for="n in 3"
                  :key="'arr-' + n"
                >
                  <img src="./assets/img/timeline_icon_right.png" alt="" />
                </span>
              </div>

              <!-- 底部时间线轨道 -->
              <div class="process-line md:top-[293px] lg:top-[305px]">
                <span class="process-line__rail"></span>
                <span class="process-line__arrow">
                  <img src="./assets/img/timeline_icon_right2.png" alt="" />
                </span>
              </div>

              <!-- 统一网格：每列纵向对齐 -->
              <div class="process-grid">
                <div v-for="(item, index) in group.steps" :key="index" class="process-col">
                  <!-- 上部：编号 + 标题 + 图标 -->
                  <div class="process-item">
                    <div class="process-head">
                      <div class="process-num">
                        <span>{{ item.num }}</span>
                      </div>
                    </div>
                    <div
                      class="process-title md:text-[22px] md:leading-[28px] lg:text-[26px] lg:leading-[1.1] xl:text-[30px] xl:leading-[1.2] relative"
                    >
                      {{ item.title }}
                      <div v-if="index == 0" class="text-[13px] bottom-[-8px] absolute xl:bottom-[-20px]">
                        （可自由參加）
                      </div>
                    </div>
                    <div class="process-circle md:w-[98px] md:h-[98px] lg:w-[110px] lg:h-[110px]">
                      <img :src="item.icon" class="process-circle__img" alt="" />
                    </div>
                  </div>

                  <!-- 时间线圆点 -->
                  <div class="process-dot">
                    <span class="process-dot__inner"></span>
                  </div>

                  <!-- 下部：时间 + 内容 -->
                  <div class="process-detail">
                    <div class="process-detail__row">
                      <span class="process-detail__icon" v-html="clockIcon"></span>
                      <span class="process-detail__label md:text-[15px] lg:text-[17px]">日期</span>
                    </div>
                    <div class="process-detail__time md:text-[13px] lg:text-[15px]" v-html="item.time"></div>
                    <div class="process-detail__row process-detail__row--mt">
                      <span class="process-detail__icon" v-html="docIcon"></span>
                      <span class="process-detail__label md:text-[15px] lg:text-[17px]">內容</span>
                    </div>
                    <div class="process-detail__content md:text-[13px] lg:text-[15px]" v-html="item.content"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 賽事獎項設置 -->
    <div class="w-[100%]">
      <div class="max-w-[1460px] w-[98%] sm:w-[96%] m-auto py-[60px] md:py-[120px]">
        <div class="text-[30px] lg:text-[36px] font-bold text-center pb-[45px] md:pb-[55px] text-[#000]">
          <!-- 獎項設置 -->
          <img src="./assets/img/3333-1.png" class="w-[320px] md:w-[460px] m-auto z-10 relative" />
        </div>
        <div class="hidden md:block">
          <ul class="flex justify-around gap-2 lg:gap-8">
            <li class="h-[800px]">
              <img
                src="https://img.kamlung.net/v23AI/Awards_01_new_.jpg"
                class="w-[100%] m-auto"
                loading="lazy"
                alt=""
              />
            </li>
            <li class="h-[800px]">
              <img src="https://img.kamlung.net/v23AI/Awards_02.jpg" class="w-[100%] m-auto" loading="lazy" alt="" />
            </li>
            <li class="h-[800px]">
              <img src="https://img.kamlung.net/v23AI/Awards_03.jpg" class="w-[100%] m-auto" loading="lazy" alt="" />
            </li>
            <li class="h-[800px]">
              <img src="https://img.kamlung.net/v23AI/Awards_04.jpg" class="w-[100%] m-auto" loading="lazy" alt="" />
            </li>
          </ul>
        </div>
        <div class="md:hidden">
          <img src="https://img.kamlung.net/v23AI/Awards2-2_1.png" class="w-[100%] m-auto" loading="lazy" alt="" />
        </div>
        <!-- <div>
          <picture>
            <source srcset="./assets/img/Awards.png" class="w-full" media="(min-width: 799px)" />
            <source srcset="./assets/img/Awards2.png" class="w-full" media="(max-width: 800px)" />
            <img src="./assets/img/Awards.png" class="w-full" loading="lazy" alt="" />
          </picture>
        </div> -->
      </div>
    </div>

    <!-- 評選準則 -->
    <div class="w-[100%]">
      <div class="max-w-[1460px] w-[92%] m-auto py-[60px] md:py-[120px]">
        <div class="text-[30px] lg:text-[36px] font-bold text-center pb-[45px] md:pb-[55px] text-[#000]">
          <img src="./assets/img/3333-2.png" class="w-[320px] md:w-[460px] m-auto z-10 relative" />
        </div>
        <div>
          <div class="md:hidden">
            <img
              src="https://img.kamlung.net/v23AI/evaluation_criteria_2.png"
              class="w-[100%] m-auto"
              loading="lazy"
              alt=""
            />
          </div>
          <div class="hidden md:block">
            <ul class="flex justify-around gap-1 lg:gap-4">
              <li>
                <img
                  src="https://img.kamlung.net/v23AI/evaluation_criteria_1_1.jpg"
                  class="md:w-[95%] lg:w-[88%] xl:w-[80%] m-auto"
                  loading="lazy"
                  alt=""
                />
              </li>
              <li>
                <img
                  src="https://img.kamlung.net/v23AI/evaluation_criteria_1_2.jpg"
                  class="md:w-[95%] lg:w-[88%] xl:w-[80%] m-auto"
                  loading="lazy"
                  alt=""
                />
              </li>
              <li>
                <img
                  src="https://img.kamlung.net/v23AI/evaluation_criteria_1_3.jpg"
                  class="md:w-[95%] lg:w-[88%] xl:w-[80%] m-auto"
                  loading="lazy"
                  alt=""
                />
              </li>
              <li>
                <img
                  src="https://img.kamlung.net/v23AI/evaluation_criteria_1_4.jpg"
                  class="md:w-[95%] lg:w-[88%] xl:w-[80%] m-auto"
                  loading="lazy"
                  alt=""
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 參賽須知 -->
    <div class="w-[100%]" id="section-intro">
      <div class="max-w-[1200px] w-[92%] m-auto py-[60px] md:py-[120px]">
        <div class="text-[30px] lg:text-[36px] font-bold text-center pb-[45px] md:pb-[55px] text-[#000]">
          <!-- 參賽須知 -->
          <img src="./assets/img/4444-1.png" class="w-[560px] md:w-[700px] m-auto z-10 relative" />
        </div>
        <!-- 法律聲明 -->
        <div class="bg-white rounded-2xl shadow-lg p-6 md:p-10 text-[#1a1a1a] leading-relaxed">
          <!-- Tab 栏 -->
          <!-- <div class="flex gap-2 md:gap-3 mb-6 md:mb-8 flex-wrap">
            <button
              v-for="(tab, idx) in ['參賽須知', '引言', '規則']"
              :key="idx"
              @click="activeIntroTab = idx"
              class="intro-tab"
              :class="{ 'intro-tab--active': activeIntroTab === idx }"
            >
              {{ tab }}
            </button>
          </div> -->

          <!-- 内容区域（可滚动） -->
          <div class="max-h-[700px] overflow-y-auto">
            <!-- Tab 0: 參賽須知 -->
            <div v-show="activeIntroTab === 0" class="text-[14px] md:text-[15px] leading-7 text-[#555]">
              <!-- 大標題 -->
              <h4 class="text-[20px] md:text-[24px] font-bold text-[#000] mb-4">活動條款及細則</h4>
              <!-- 前言 -->
              <p class="text-[18px] md:text-[20px] leading-7 mb-5 font-bold text-[#000]">
                參賽者凡提交作品，即視為已詳閱、理解並同意本《活動條款及細則》全部條款。如有爭議，主辦方保留最終決定權。
              </p>
              <h5 class="text-[15px] md:text-[16px] text-[#000] mt-5 mb-2">
                1. 【全港iCAUR V23
                AI設計比賽】（下稱比賽）之報名日期是由2026年6月18日至2026年8月18日23:59:59。本比賽之主辦方為Star Auto
                Holding Limited (下稱iCAUR香港) 。
              </h5>
              <h5 class="text-[15px] md:text-[16px] text-[#000] mt-5 mb-2">
                2.
                參賽者在提交作品前，請確保已閱讀並完全同意本比賽所有規則。任何違反比賽規則、或不符合參賽資格（包括但不限於身份、地域限制）之作品，iCAUR香港有權取消其參賽資格，恕不另行通知。
              </h5>
              <h5 class="text-[15px] md:text-[16px] text-[#000] mt-5 mb-2">
                3.
                每位參賽者只能參選一個組別，並只遞交一份作品，如重覆遞交者，將以最後一份遞交之作品作準，其餘則不獲受理並不另作通知。如參賽者被發現參加兩個組別，則自動被取消其參賽資格。
              </h5>
              <h5 class="text-[15px] md:text-[16px] text-[#000] mt-5 mb-2">
                4.
                參賽作品必須為參賽者原創，未曾在任何公開場合發表、未授權予任何第三方使用，且不得抄襲、盜用、仿冒或侵犯任何第三方之著作權、商標權、專利權或其他知識產權。如發現參賽者侵犯版權或其他相關罪行，當中包括但不限於遞交借用、轉載、複製及假冒的參賽作品等，其參賽資格將被取消。參賽者須要自行承擔法律責任，任何法律糾紛一概與iCAUR香港無關。
              </h5>
              <h5 class="text-[15px] md:text-[16px] text-[#000] mt-5 mb-2">
                5.
                iCAUR香港將對所有提交作品進行內容安全審查，包括但不限於暴力、色情、歧視、不雅、誹謗、政治敏感、違法或任何其他具爭議性的內容。iCAUR香港有權刪除違規作品、取消參賽資格及追回已頒發之獎項。參賽者須接受並尊重主辦方之最終決定。
              </h5>
              <h5 class="text-[15px] md:text-[16px] text-[#000] mt-5 mb-2">
                6.
                參賽作品中所有字體必須為合法授權（如免費商用字體）或參賽者自創字體。如作品包含非原創素材（如圖像、音樂、影片片段等），參賽者必須取得該素材合法之使用授權書，並承擔全部法律責任。
              </h5>
              <h5 class="text-[15px] md:text-[16px] text-[#000] mt-5 mb-2">
                7. 參賽者如使用人工智能（AI）工具輔助創作，需確保生成內容不侵犯第三方版權。參賽者須對AI
                生成內容的合法性負全責。若因參賽作品引發任何著作權、商標權或其他知識產權糾紛，參賽者須自行承擔全部法律責任及賠償損失，iCAUR香港概不負責，並保留取消參賽資格或追回獎項之權利。
              </h5>
              <h5 class="text-[15px] md:text-[16px] text-[#000] mt-5 mb-2">
                8.
                參賽期間及比賽結束後，參賽者不得將參賽作品轉讓、授權、出售或授權予任何第三方。同時，參賽作品不得用於與本比賽性質相同或類似之其他平台、品牌或活動，以免構成侵權或混淆。
              </h5>
              <h5 class="text-[15px] md:text-[16px] text-[#000] mt-5 mb-2">
                9.
                參賽者須確保所提交之個人資料正確，iCAUR香港有權取消任何其認為提交錯誤或不完整資料或有不誠實行為的參賽者的參加資格。如有任何爭議，iCAUR香港保留最終決定權及解釋權。
              </h5>
              <h5 class="text-[15px] md:text-[16px] text-[#000] mt-5 mb-2">
                10.
                iCAUR香港有權要求得獎者提供身分證明資料以作核對身分之用，核實身分後方可領獎。獲獎者須於公佈後指定時間內回覆確認，並配合主辦方完成領獎程序。逾期未回覆或拒絕配合者，視為自動棄權，主辦方有權將獎項順延至候補者，恕不另行通知。
              </h5>
              <h5 class="text-[15px] md:text-[16px] text-[#000] mt-5 mb-2">
                11.
                iCAUR香港在賽事期間及賽後，享有對全部參賽作品進行宣傳、展示、推廣之權利（包括在官方網站、社交媒體、新聞稿及線下展覽中使用），使用時將適當署名作者姓名。iCAUR香港無需向參賽者支付任何費用。
              </h5>
              <h5 class="text-[15px] md:text-[16px] text-[#000] mt-5 mb-2">
                12. iCAUR香港有權將獲獎作品（或基於獲獎作品設計之衍生圖案）進行3D
                打印，製作成實物模型、紀念品、展覽品等。獲獎參賽者需配合提供作品源文件（如AI、PSD、C4D
                等），以便主辦方進行後續開發或印刷。
              </h5>
              <h5 class="text-[15px] md:text-[16px] text-[#000] mt-5 mb-2">
                13.
                所有提交作品時間將以技術支援公司之伺服器接收時間為準。比賽後期作品上傳量龐大，請參賽者合理安排時間，提早提交作品，避免在最後一刻集中上傳，以免因系統繁忙導致上傳失敗或重複提交。主辦方不對因技術問題或延遲提交造成之損失負責。
              </h5>
              <h5 class="text-[15px] md:text-[16px] text-[#000] mt-5 mb-2">
                14.
                如發現或懷疑有損害參與過程、或干預活動或網站運作，或有違反活動規則的行為及/或詐騙個案，iCAUR香港有權取消任何參賽或獲獎人士的參加及/或獲獎資格。如有任何參加資格被取消事宜，有關參賽者將不獲通知。
              </h5>
              <h5 class="text-[15px] md:text-[16px] text-[#000] mt-5 mb-2">
                15.
                不論是由互聯網，或是任何由技術或人為失誤而產生或導致的相關設備、程式或程序錯誤，引致不正確或不準確的報名資料，iCAUR香港恕不負責。
              </h5>
              <h5 class="text-[15px] md:text-[16px] text-[#000] mt-5 mb-2">
                16. 如果參賽者或其參賽作品牽涉任何法律責任或導致iCAUR香港蒙受任何損失，iCAUR香港將會保留一切追究權利。
              </h5>
              <h5 class="text-[15px] md:text-[16px] text-[#000] mt-5 mb-2">
                17.
                所有比賽評選結果將以iCAUR香港的最後決定為依歸，參賽者對有關評選的所有結果不得異議，比賽亦不設上訴機制。
              </h5>
              <h5 class="text-[15px] md:text-[16px] text-[#000] mt-5 mb-2">
                18. iCAUR香港保留修改比賽規則、獎項內容、評審方式及取消比賽之權利，恕不另行通知。
              </h5>
              <h5 class="text-[15px] md:text-[16px] text-[#000] mt-5 mb-2">
                19. 尚有任何意見或爭論，則以iCAUR香港的決策為最終決定。
              </h5>
            </div>

            <!-- Tab 1: 引言 -->
            <!-- <div v-show="activeIntroTab === 1">
              <div class="text-[14px] md:text-[16px] text-[#333] leading-8 mb-6">
                <div class="text-[15px] md:text-[17px] font-bold text-[#000] mb-6">
                  敢衝破束縛，方顯玩家本色。秉承「BORN TO PLAY」理念，迎合舒適都市出行，更能真正能攀山洩水越野的純電車
                  ！ iCAUR 召集全港與各地創意高手一較高下。玩轉方盒，釋放靈感！運用AI 打造專屬風格。
                </div>
                <div class="text-[15px] md:text-[17px] font-bold text-[#000] mb-6">
                  奇瑞汽車（CHERY AUTO）旗下新能源品牌 iCAUR 2026 年正式登錄香港。 首次與 騰訊(TENCENT) 合作為官方 AI
                  合作夥伴，今年夏天舉辦一項設計盛事「全港 iCAUR V23 AI
                  汽車設計比賽」，適合學生及公開組不同界別人士參與。
                </div>
                <div class="text-[15px] md:text-[17px] font-bold text-[#000] mb-6">
                  本次活動旨在推動由最新 AI
                  技術賦能並釋放個人設計創意，為香港學生，設計師以至廣大車迷，搭建一個直接與中國汽車製造商溝通認識的平臺，展示個人風格與潛力，探索潛在的職業發展機遇。
                  勝出者可前往參觀2026年奇瑞全球品牌大會（預計10月）及參觀奇瑞汽車最新的 AI 智能生產工廠。
                  勝出設計作品更有機會在真實市場中展出及投入商業化生產。
                </div>
                <div class="text-[15px] md:text-[17px] font-bold text-[#000] mb-6">
                  大賽將於 2026 年 6 月 18 日至 22 日
                  在亞洲國際博覽館舉行的「2026年香港國際汽車及供應鏈博覽會」媒體發布會上正式宣佈啟動。
                </div>
              </div>
            </div> -->

            <!-- Tab 2: 規則 -->
            <!-- <div v-show="activeIntroTab === 2">
              <p class="text-[14px] md:text-[15px] text-[#555] leading-8 mb-5">
                奇瑞汽車（CHERY AUTO）旗下新能源品牌 iCAR 2026 年正式登錄香港。首次與騰訊 (TENCENT) 合作為官方 AI
                合作夥伴，今年夏天舉辦一項設計盛事「全港 iCAR V23 AI 汽車設計比賽」，適合學生及公開組不同界別人士參與。
              </p>
              <p class="text-[14px] md:text-[15px] text-[#555] leading-8 mb-5">
                本次活動旨在推動由最新 AI
                技術賦能並釋放個人設計創意，為香港學生、設計師以至廣大車迷，搭建一個直接與中國汽車製造商溝通認識的平臺，展示個人風格與潛力，探索潛在的職業發展機遇。勝出者可前往參觀
                2026 年奇瑞全球品牌大會（預計 10 月）及參觀奇瑞汽車最新的 AI
                智能生產工廠。勝出設計作品更有機會在真實市場中展出及投入商業化生產。
              </p>
              <p class="text-[14px] md:text-[15px] text-[#555] leading-8">
                大賽將於 2026 年 6 月 18 日至 22 日在亞洲國際博覽館舉行的「2026
                年香港國際汽車及供應鏈博覽會」媒體發布會上正式宣佈啟動。
              </p>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 榮譽評審嘉賓 -->
    <div class="w-[100%]" id="section-intro">
      <div class="max-w-[1200px] w-[92%] m-auto py-[60px] md:py-[120px]">
        <div class="text-[30px] lg:text-[36px] font-bold text-center pb-[45px] md:pb-[55px] text-[#000]">
          <!-- 榮譽評審嘉賓 -->
          <img src="./assets/img/4444-2.png" class="w-[560px] md:w-[700px] m-auto z-10 relative" />
        </div>
        <div class="judges-grid gap-6 md:gap-7 xl:gap-12 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 text-center">
          <div v-for="(judge, idx) in judges" :key="'judge-' + idx" class="judge-card px-[4px]">
            <!-- <div class="judge-card__avatar">
              <img v-if="judge.img" :src="judge.img" :alt="judge.name" class="judge-card__img" />
              <span v-else class="judge-card__initials">{{ judge.initials }}</span>
            </div> -->
            <div class="pt-[15px] text-[#111] text-[16px] md:text-[18px] font-bold">{{ judge.nameEn }}</div>
            <div class="pb-2 text-[#111] text-[12px]" v-if="judge.name">({{ judge.name }})</div>
            <div class="pb-[15px] text-[#666] text-[12px] md:text-[14px]" v-html="judge.title"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 作品參考 -->
    <div class="w-[100%]" id="section-reference">
      <div class="max-w-full w-[92%] m-auto py-[60px] md:py-[80px]">
        <div class="text-[30px] lg:text-[36px] font-bold text-center pb-[45px] md:pb-[55px] text-[#000]">
          <!-- 作品參考 -->
          <img src="./assets/img/5555.png" class="w-[320px] md:w-[460px] m-auto z-10 relative" />
        </div>
        <div class="max-w-full mx-auto">
          <swiper ref="worksSwiper" :options="swiperOptions" class="works-swiper">
            <swiper-slide v-for="(img, idx) in workImages" :key="idx">
              <div class="work-slide">
                <img :src="img" :alt="'作品參考 ' + (idx + 1)" class="work-slide__img" loading="lazy" />
              </div>
            </swiper-slide>
            <div class="swiper-pagination-works" slot="pagination"></div>
          </swiper>
        </div>
      </div>
    </div>

    <!-- style="background-image: url('https://www.kamlung.net/images/icaur/other/icaur_bg.jpg')" -->
    <!-- <div class="w-[100%] bg-cover bg-top py-[80px] md:py-[120px]" id="section-rules">
      <div class="max-w-[1200px] w-[92%] m-auto pb-[50px] md:pb-[40px] text-center text-[#333] font-bold">
        <div class="lg:text-[36px] text-[30px] md:pt-[80px] pt-[60px] pb-[40px] text-[#333]">參賽規則</div>
        <ul class="px-5 py-5 text-[16px] flex flex-col flex-wrap">
          <li>條款</li>
          <li>e.g.</li>

          <li>不能重複提交作品 去其他比賽</li>

          <li>所有提交的參賽圖後，同意 klm 使用該設計稿 ，做宣傳 用途</li>

          <li>賽事規則： 統一使用ai Gemini 或騰訊</li>
          <li>檔案需包含參賽者姓名，設計理念</li>
        </ul>
      </div>
    </div> -->
    <!-- <div @click="testFn">test</div> -->

    <!-- 立即报名 -->
    <!-- <div class="text-[30px] lg:text-[36px] font-bold text-center pb-[45px] md:pb-[55px] text-[#000]">
      <img src="./assets/img/6666.png" class="w-[320px] md:w-[460px] m-auto z-10 relative" />
    </div> -->
    <div id="registration"></div>
    <!-- <form-page ref="formPageRef"></form-page> -->

    <div></div>

    <!-- 贊助夥伴 -->
    <div class="w-full py-[50px] md:py-[80px]">
      <div class="max-w-[1200px] w-[90%] m-auto">
        <h3 class="text-[22px] md:text-[30px] font-bold text-center text-[#222] mb-[30px] md:mb-[50px]">特別鳴謝</h3>
        <div class="sponsor-grid">
          <div class="sponsor-item">
            <img src="./assets/img/sponsorship/1.png" alt="" />
          </div>
          <div class="sponsor-item">
            <img src="./assets/img/sponsorship/2.png" alt="" />
          </div>
          <div class="sponsor-item">
            <img src="./assets/img/sponsorship/5.png" alt="" />
          </div>
          <div class="sponsor-item">
            <img src="./assets/img/sponsorship/6.png" alt="" />
          </div>
          <div class="sponsor-item">
            <img src="./assets/img/sponsorship/7.png" alt="" />
          </div>
        </div>
      </div>
    </div>

    <footer-page></footer-page>

    <!-- 倒计时卡片（左侧固定） -->
    <div class="countdown-wrapper" :class="{ 'countdown-wrapper--visible': showCountdown }">
      <div class="countdown-card">
        <div
          class="countdown-card__header bg-[rgba(0,0,0,0.1)] cursor-pointer"
          @click="handleClick('registration', '1')"
        >
          {{ countdown.stageTitle || '倒計時' }}
        </div>
        <div class="countdown-card__body">
          <div class="countdown-card__num">{{ countdown.days }}</div>
          <div class="countdown-card__unit">DAYS</div>
          <div class="countdown-card__detail">
            <span>{{ String(countdown.hours).padStart(2, '0') }}</span>
            :
            <span>{{ String(countdown.minutes).padStart(2, '0') }}</span>
            :
            <span>{{ String(countdown.seconds).padStart(2, '0') }}</span>
          </div>
        </div>
        <!-- 阶段指示器 -->
        <!-- <div class="countdown-card__stages">
          <div
            v-for="(s, i) in countdownStages"
            :key="i"
            class="countdown-card__stage-dot"
            :class="{
              'countdown-card__stage-dot--active': i === countdown.stageIndex,
              'countdown-card__stage-dot--done': i < countdown.stageIndex,
            }"
            :title="s.title"
          >
            <span>{{ s.title.charAt(0) }}</span>
          </div>
          <div class="countdown-card__stage-line">
            <div
              class="countdown-card__stage-line-fill"
              :style="{ width: (countdown.stageIndex / (countdownStages.length - 1)) * 100 + '%' }"
            ></div>
          </div>
        </div> -->
      </div>
    </div>

    <div class="countdown-wrapper countdown-wrapper3 countdown-wrapper--visible">
      <div class="countdown-card">
        <!-- <div class="countdown-card__header cursor-pointer" @click="showPopup = true">下載教學影片</div> -->

        <router-link to="/gallery"><div class="countdown-card__header cursor-pointer">入圍作品</div></router-link>
      </div>
    </div>
    <!-- <div class="countdown-wrapper countdown-wrapper2 countdown-wrapper--visible">
      <div class="countdown-card countdown-card2">
        <div class="countdown-card__header cursor-pointer" @click="handleClick('registration', '2')">
          免費獲取 Token
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
// import { carouselList, textList, imgsrc } from '@/assets/js/static.js'
// import FormPage from '@/components/FormPage.vue'
import FooterPage from '@/components/FooterPage.vue'
import NavBar from '@/components/NavBar.vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: 'HomeView',
  components: {
    // FormPage,
    FooterPage,
    NavBar,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      // imageUrl: require("@/assets/img/list/7.jpg"),
      // imgsrc,
      // carouselList,
      // textList,
      speak: '中文',
      navItems: [
        { key: 'home', label: '首頁', target: '#section-banner', href: '/' },
        { key: 'process', label: '賽事進程', target: '#section-process', href: '/' },
        { key: 'intro', label: '活動條款及細則', target: '#section-intro', href: '/' },
        { key: 'reference', label: '作品參考', target: '#section-reference', href: '/' },
        // { key: 'registration', label: '上傳作品', target: '#registration', href: '/' },
        { key: 'gallery', label: '入圍作品', href: '/gallery' },
        { key: 'ranking', label: '獲獎公示', href: '/ranking' },
      ],
      // 时钟图标
      clockIcon:
        '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><polyline points="12 7 12 12 15 14"></polyline></svg>',
      // 文档图标
      docIcon:
        '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="8" y1="13" x2="16" y2="13"></line><line x1="8" y1="17" x2="14" y2="17"></line></svg>',
      // 作品參考轮播图
      workImages: [
        'https://img.kamlung.net/v23AI/arr/0ff3918f037de29c9c47d888752905ec.jpg',
        'https://img.kamlung.net/v23AI/arr/2a966d15555ba66c062b419c625797ba.jpg',
        'https://img.kamlung.net/v23AI/arr/3287a207c0ca612e6aeb575dc74e5559.jpg',
        'https://img.kamlung.net/v23AI/arr/40859c7cb26138a26cef20dd7e3cb32e.jpg',
        'https://img.kamlung.net/v23AI/arr/614d8a9835c4255a64c25c10954d7502.jpg',
        'https://img.kamlung.net/v23AI/arr/c46a9185a199b5a79453f87ff1f67f0b.jpg',
        'https://img.kamlung.net/v23AI/arr/cab98cd47ae8922421a243ffd007f10c.jpg',
        'https://img.kamlung.net/v23AI/arr/edf8fcdf9fcf8ec0a34c20c6f77129d8.jpg',
      ],
      swiperOptions: {
        slidesPerView: 1.15,
        spaceBetween: 12,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination-works',
          clickable: true,
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      },
      activeIntroTab: 0,
      showPopup: false,
      countdownStages: [
        { title: '上傳作品', deadline: new Date('2026-08-16T23:59:59') },
        { title: '作品評審', deadline: new Date('2026-08-24T00:00:00') },
        { title: '公佈結果', deadline: new Date('2026-09-11T23:59:59') },
      ],
      countdown: { days: 0, hours: 0, minutes: 0, seconds: 0, stageTitle: '', stageIndex: 0, ended: false },
      countdownTimer: null,
      showCountdown: false,
      judges: [
        // {
        //   initials: 'JL',
        //   nameEn: 'Dr. James Li, JP',
        //   name: '李子樹博士太平紳士',
        //   title: '騰訊集團公共事務副總裁',
        // },
        {
          initials: 'SJ',
          nameEn: 'Mr. Su Jun',
          name: '蘇駿先生',
          title: '奇瑞 iCAR 事業部總經理',
        },
        {
          initials: 'DC',
          nameEn: 'Mr. David Chu',
          name: '朱欽騏先生',
          title: 'Nautica 創辦人<br/> Georg Jensen CEO (2013) <br/> TUMI首席創意官 (2007)',
        },
        {
          id: 4,
          // img: require('@/assets/img/judge/Daniel Chan.jpg'),
          initials: 'DC',
          nameEn: 'Mr. Daniel Chan',
          name: '陳光耀先生',
          title: '香港知專設計學院 (HKDI) 建築、室內及產品設計系系主任',
        },
        {
          initials: 'LC',
          nameEn: 'Dr. Lina Chun',
          name: '秦彰婧博士',
          title: 'HKU SPACE 智慧城市規劃講師',
        },
        {
          initials: 'SL',
          nameEn: 'Prof. Sunnie Lau',
          name: '劉昇陽教授',
          title: '香港註冊建築師',
        },
        {
          initials: 'YW',
          nameEn: 'Dr. Yvonne Wong',
          name: '黃麗芳女士',
          title: '互聯網專業協會副會長 <br/> 大灣區 5G 產業聯盟副主席兼董事',
        },
        {
          initials: 'DP',
          nameEn: 'Mr. Daniel Pang',
          name: ' 彭志揚先生',
          title: '資深汽車媒體 “駕駛艙” 主編及主播 ',
        },
        {
          initials: 'JL',
          nameEn: 'Mr. John Leung',
          name: ' 梁栢福先生',
          title: '錦龍汽車集團董事 <br/> 通用汽車設計師 (2012)',
        },
      ],
      processGroups: [
        {
          // title: '作品徵集期',
          steps: [
            // {
            //   num: '01',
            //   title: '報名參賽',
            //   time: '2026 年 6 月 18 日 – 6 月 22 日',
            //   content: '開放報名，自由參賽！',
            //   icon: require('@/assets/img/icon1.png'),
            // },
            {
              num: '01',
              title: '參加騰訊混元3D AI 培訓工作坊',
              time: '2026年6月25日（星期四）<br/> 下午 4 時至 6 時 <br/> 地點：民青局賽馬會青立方 <br/><div class="invisible inline">地點</div> （柴灣柴灣道238號青年廣場4樓）',
              content:
                '凡出席「騰訊混元3D AI培訓工作坊」者，均獲發AI基礎培訓證書乙張。出席實體工作坊的參加者，將可獲得小禮物乙份。<br/>*工作坊以雙軌模式，線上線下同時進行，參加者請自備手提電腦，可同步操作混元3D。',
              icon: require('@/assets/img/icon2.png'),
            },
            {
              num: '02',
              title: '參加者提交作品',
              time: '2026 年 6 月 18 日 00:00 — <br/> 2026 年 8 月 18 日 23:59',
              content:
                '接受投稿，參加者可自由創作，並於限期前上載作品。<br/> 無論你用傳統設計軟件，還是 AI 平台輔助設計，全部無任歡迎。',
              icon: require('@/assets/img/icon3.png'),
            },
            {
              num: '03',
              title: '作品評審期',
              time: '2026 年 8 月 24 日 — <br/> 2026 年 8 月 31 日',
              content: '入圍作品將於網頁公開展示。專業評審團將進行篩選，選出優異作品。',
              icon: require('@/assets/img/icon4.png'),
            },
            {
              num: '04',
              title: '公佈結果',
              time: '2026 年 9 月 11 日',
              content: '得獎作品將於活動網頁及 iCAUR 香港 Facebook 專頁公佈。得獎者將獲專人通知領獎。',
              icon: require('@/assets/img/icon6.png'),
            },
          ],
        },
        // {
        //   title: '結果公示期',
        //   steps: [
        //     {
        //       num: '04',
        //       title: '作品評審',
        //       time: '2026 年 8 月 1 日 – 8 月 24 日',
        //       content: '專業評委團進行線上評審，篩選出入圍作品。',
        //       icon: require('@/assets/img/icon4.png'),
        //     },
        //     {
        //       num: '05',
        //       title: '線上公佈',
        //       time: '2026 年 8 月 24 日 – 9 月 3 日',
        //       content: '公佈入圍名單，並開放線上投票（如適用）。',
        //       icon: require('@/assets/img/icon5.png'),
        //     },
        //     {
        //       num: '06',
        //       title: '最終頒獎典禮',
        //       time: '2026 年 9 月 3 日',
        //       content: '於香港現場公佈最終獲獎名單，頒發獎金及證書，並展示 3D 打印成品模型。',
        //       icon: require('@/assets/img/icon6.png'),
        //     },
        //   ],
        // },
      ],
    }
  },
  computed: {
    allSteps() {
      const arr = []
      this.processGroups.forEach((g) => {
        g.steps.forEach((s) => {
          arr.push({ ...s, groupTitle: g.title })
        })
      })
      return arr
    },
  },
  mounted() {
    // 倒计时初始化
    this.updateCountdown()
    this.countdownTimer = setInterval(this.updateCountdown, 1000)
    // 滚动监听：倒计时卡片飞入动画
    window.addEventListener('scroll', this.handleScroll)
    // 首次访问弹窗
    this.showPopup = false
    //可能是router没准备好，用this.$router.onReady解决
    // this.$router.onReady(() => {
    //   let query = this.$route.query;
    //   console.log("onReady :>>query ", query);n
    // });
    // console.log("(this.$i18n.locale :>>11 ", this.$i18n.locale);
    // console.log("this.$route.query.lang :>> ", this.$route.query);
    // if (this.$route?.query?.lang) {
    //   console.log("存在 :>> ");
    //   if (this.$route.query.lang === "en") {
    //     this.$i18n.locale = "en";
    //     this.$refs.formPageRef.changeLanguage("zh");
    //     window.sessionStorage.setItem("sessionLang", "en");
    //   } else {
    //     this.$i18n.locale = "zh";
    //     this.$router.push({ path: "/survey", query: { lang: "zh" } }).catch((data) => {
    //       console.log("data :>>00 ", data);
    //     });
    //     window.sessionStorage.setItem("sessionLang", "zh");
    //   }
    // } else {
    //   let lang = window.sessionStorage.getItem("sessionLang") || "zh";
    //   console.log("不存在 :>> -sessionStorage", lang);
    //   if (lang === "zh") {
    //     console.log("进入11111", lang);
    //     this.$router.push({ path: "/survey", query: { lang: "zh" } }).catch((data) => {
    //       console.log("data :>> 1", data);
    //     });
    //     this.$i18n.locale = "zh";
    //   } else {
    //     console.log("进入22222", lang);
    //     this.$router.push({ path: "/survey", query: { lang: "en" } }).catch((data) => {
    //       console.log("data :>>2 ", data);
    //     });
    //     this.$i18n.locale = "en";
    //     this.$refs.formPageRef.changeLanguage("zh");
    //   }
    // }
  },
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
    }
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    updateCountdown() {
      const now = new Date()
      let currentStage = null
      let stageIndex = 0
      for (let i = 0; i < this.countdownStages.length; i++) {
        if (now < this.countdownStages[i].deadline) {
          currentStage = this.countdownStages[i]
          stageIndex = i
          break
        }
      }
      if (!currentStage) {
        this.countdown = {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
          stageTitle: '已公佈結果',
          stageIndex: this.countdownStages.length - 1,
          ended: true,
        }
        return
      }
      const diff = currentStage.deadline - now
      const days = Math.floor(diff / (1000 * 60 * 60 * 24))
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((diff % (1000 * 60)) / 1000)
      this.countdown = { days, hours, minutes, seconds, stageTitle: currentStage.title, stageIndex, ended: false }
    },
    handleScroll() {
      const banner = document.getElementById('section-banner')
      if (!banner) return
      const bannerHeight = banner.offsetHeight
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      this.showCountdown = scrollTop > bannerHeight * 0.9
    },
    handleClick() {
      console.log('ranking')
      this.$router.push({ path: '/ranking' }, () => {
        window.scrollTo(0, 0)
      })
      // const el = document.getElementById(id)id, num
      // if (el) {
      //   const top = el.getBoundingClientRect().top + window.pageYOffset - 150
      //   this.smoothScrollTo(top, 600)
      // }
      // if (num) {
      //   console.log('num :>> ', Number(num))
      //   this.$refs.formPageRef.switchForm(Number(num))
      // }
    },
    popupRegister(e) {
      let text = e || 'registration'
      this.showPopup = false
      this.$nextTick(() => {
        this.handleClick(text, '0')
      })
    },
    popupRegister2() {
      window.open('https://tinyurl.com/TencentHY3D-HowTo-202607', '_blank')
    },
    closePopup() {
      this.showPopup = false
    },
    smoothScrollTo(targetY, duration) {
      const startY = window.pageYOffset
      const diff = targetY - startY
      let startTime = null
      const step = (timestamp) => {
        if (!startTime) startTime = timestamp
        const progress = Math.min((timestamp - startTime) / duration, 1)
        const ease = progress < 0.5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2
        window.scrollTo(0, startY + diff * ease)
        if (progress < 1) requestAnimationFrame(step)
      }
      requestAnimationFrame(step)
    },
    // changeLanguage(lang) {
    //   console.log("changelang :>> ", lang);
    //   let lang_ = lang === "zh" ? "en" : "zh";
    //   this.$i18n.locale = lang_;
    //   window.sessionStorage.setItem("sessionLang", lang_);
    //   this.$refs.formPageRef.changeLanguage(lang);
    //   if (lang === "zh") {
    //     this.$router.push({ path: "/survey", query: { lang: "en" } }).catch((data) => {
    //       console.log("data :>> 3", data);
    //     });
    //     // this.$router.push(getLocalePath('/about', 'en'))
    //   } else {
    //     this.$router.push({ path: "/survey", query: { lang: "zh" } }).catch((data) => {
    //       console.log("data :>>4 ", data);
    //     });
    //   }
    // },
    // testFn() {
    //   console.log("this.$i18n.locale :>> ", this.$i18n.locale);
    // },
  },
}
</script>

<style lang="scss" scoped>
@import 'element-ui/lib/theme-chalk/display.css';

* {
  --brand: #ff6a13;
  --ink: #1f1f1f;
}

.img {
  object-fit: cover;
}
::v-deep .swiper-pagination-bullet-active {
  background: #f48e30 !important;
}
.contaier {
  .top-nvb_box {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    border-bottom: #cccccc8c solid 1px;
    z-index: 1000;
    // background-color: #fff;
    backdrop-filter: blur(10px);
    //background-color: #fafafab3 !important;

    .top-nvb {
      position: relative;
      max-width: 1200px;
      margin: 0 auto;
      // padding: 20px 0;

      .logo-box {
        max-width: 120px;
        // margin: 0 auto;
      }

      .lang {
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translate(0%, -50%);
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
}

.top-banner {
  width: 100%;

  img {
    display: block;
    width: 100%;
    object-fit: cover;
  }
}

/* 使用伪元素 ::before 制作45度斜线 */
.diagonal-line-container::before {
  content: '';
  position: absolute;
  /* 线条宽度：父容器宽度的70%，确保视觉效果适中 */
  width: 70%;
  /* 线条厚度：4px，醒目且精致 */
  height: 3px;
  /* 背景色：使用Tailwind的靛蓝色系（可直接用色值，也可配合tailwind主题） */
  background-color: #f48e30; /* indigo-600 */
  /* 圆角过渡，让线条更柔和 */
  border-radius: 4px;
  /* 定位到父容器中心 */
  top: 0%;
  left: 10%;
  /* 先居中再旋转45度，确保旋转轴心为线条中心 */
  transform: translate(-50%, -50%) rotate(125deg);
  /* 添加轻微阴影提升立体感 */
  // box-shadow: 0 2px 8px rgba(79, 70, 229, 0.1);
  /* 确保斜线在背景之上但在内容之下（z-index协调） */
  z-index: 5;
}

/* 可选：悬停时增加斜线动画效果，展示伪类的交互能力（非必须，但体现伪类） */
.diagonal-line-container:hover::before {
  transform: translate(-50%, -50%) rotate(125deg) scale(1.05);
  transition: transform 0.3s ease;
  background-color: #f48e30; /* 悬停时变为紫色 */
  // box-shadow: 0 4px 12px rgba(124, 58, 237, 0.1);
}

.diagonal-line-container::after {
  content: '';
  position: absolute;
  /* 线条宽度：父容器宽度的70%，确保视觉效果适中 */
  width: 70%;
  /* 线条厚度：4px，醒目且精致 */
  height: 3px;
  /* 背景色：使用Tailwind的靛蓝色系（可直接用色值，也可配合tailwind主题） */
  background-color: #f48e30; /* indigo-600 */
  /* 圆角过渡，让线条更柔和 */
  border-radius: 4px;
  /* 定位到父容器中心 */
  bottom: 0%;
  left: 90%;
  /* 先居中再旋转45度，确保旋转轴心为线条中心 */
  transform: translate(-50%, -50%) rotate(125deg);
  /* 添加轻微阴影提升立体感 */
  // box-shadow: 0 2px 8px rgba(79, 70, 229, 0.1);
  /* 确保斜线在背景之上但在内容之下（z-index协调） */
  z-index: 5;
}
.diagonal-line-container:hover::after {
  transform: translate(-50%, -50%) rotate(125deg) scale(1.05);
  transition: transform 0.3s ease;
  background-color: #f48e30; /* 悬停时变为紫色 */
  // box-shadow: 0 4px 12px rgba(124, 58, 237, 0.1);
}

/* ==================== 倒计时卡片 ==================== */
.countdown-wrapper {
  position: fixed;
  left: 6px;
  top: 120px;
  transform: translateX(-150%);
  z-index: 9999;
  opacity: 0;
  transition: transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.5s ease;
  pointer-events: none;
}
.countdown-wrapper2 {
  left: auto !important;
  right: 4px !important;
  top: 16px;
  background: rgba(0, 0, 0, 0) !important;
}
.countdown-wrapper3 {
  left: 4px !important;
  top: 16px;
  background: rgba(0, 0, 0, 0) !important;
}
.countdown-wrapper--visible {
  transform: translateX(0);
  opacity: 1;
  pointer-events: auto;
}
@media (min-width: 768px) {
  .countdown-wrapper {
    left: 16px;
    top: 158px;
  }
  .countdown-wrapper2 {
    left: auto !important;
    right: 16px !important;
    top: 16px;
  }
  .countdown-wrapper3 {
    left: 16px !important;
    top: 16px;
  }
}

.countdown-card {
  width: 88px;

  border-radius: 11px;
  overflow: hidden;
  background: linear-gradient(180deg, #fa7e4a 0%, #f36d05 45%, #fdc77d 100%);
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.15);
}
.countdown-card2 {
  width: 105px;
}
@media (min-width: 768px) {
  .countdown-card {
    width: 130px;
    border-radius: 16px;
  }
}

.countdown-card__header {
  padding: 5px 0;
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.3px;
}
@media (min-width: 768px) {
  .countdown-card__header {
    padding: 9px 0;
    font-size: 14px;
    letter-spacing: 1px;
  }
}

.countdown-card__body {
  padding: 10px 6px 8px;
  text-align: center;
}
@media (min-width: 768px) {
  .countdown-card__body {
    padding: 18px 10px 14px;
  }
}

.countdown-card__num {
  font-size: 28px;
  font-weight: 800;
  color: #fff;
  line-height: 1;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}
@media (min-width: 768px) {
  .countdown-card__num {
    font-size: 44px;
  }
}

.countdown-card__unit {
  font-size: 8px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.9);
  letter-spacing: 2px;
  margin-top: 2px;
}
@media (min-width: 768px) {
  .countdown-card__unit {
    font-size: 11px;
    letter-spacing: 4px;
    margin-top: 4px;
  }
}

.countdown-card__detail {
  margin-top: 5px;
  font-size: 10px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: 0.5px;
}
@media (min-width: 768px) {
  .countdown-card__detail {
    margin-top: 10px;
    font-size: 13px;
    letter-spacing: 2px;
  }
}

/* 阶段指示器 */
.countdown-card__stages {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px 14px;
}

.countdown-card__stage-dot {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.7);
  z-index: 1;
  transition: all 0.3s;
}
.countdown-card__stage-dot--active {
  background: #e64a19;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
.countdown-card__stage-dot--done {
  background: rgba(255, 255, 255, 0.7);
  color: #e64a19;
}

.countdown-card__stage-line {
  position: absolute;
  left: 32px;
  right: 32px;
  top: 50%;
  height: 3px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  transform: translateY(-50%);
  z-index: 0;
  overflow: hidden;
}
.countdown-card__stage-line-fill {
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 2px;
  transition: width 0.5s ease;
}

/* ==================== 參賽須知 Tab 样式 ==================== */
.intro-tab {
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  border: 1.5px solid #ddd;
  background: #f9f9f9;
  color: #666;
  cursor: pointer;
  transition: all 0.25s ease;
  outline: none;
}
.intro-tab:hover {
  background: #f0f0f0;
  border-color: #ccc;
}
.intro-tab--active {
  background: #f15108;
  color: #fff;
  border-color: #f15108;
  box-shadow: 0 2px 8px rgba(241, 81, 8, 0.3);
}
.intro-tab--active:hover {
  background: #d9470a;
  border-color: #d9470a;
}
@media (min-width: 768px) {
  .intro-tab {
    padding: 10px 28px;
    font-size: 16px;
    border-radius: 10px;
  }
}

/* ==================== 赛事进程 (桌面端) ==================== */
@media (min-width: 768px) {
  .process-timeline {
    --brand: #ff6a13;
    --brand-soft: #fff1e6;
    --brand-line: #ff6a13;
    --ink: #1f1f1f;
    --ink-sub: #555;
    position: relative;
  }

  /* 分组容器 */
  .process-group {
    margin-bottom: 64px;
  }
  .process-group:last-child {
    margin-bottom: 0;
  }

  /* 分组大标题 */
  .process-group__title {
    text-align: center;
    font-size: 32px;
    font-weight: 700;
    color: var(--brand);
    margin-bottom: 48px;
    letter-spacing: 2px;
    position: relative;
    padding-bottom: 14px;
  }
  .process-group__title::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: var(--brand);
    border-radius: 2px;
  }

  /* 分组内部相对定位 */
  .process-group__body {
    position: relative;
  }

  .process-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
  }

  /* 每列纵向容器 */
  .process-col {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  /* 时间线圆点 */
  .process-dot {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 2;
    margin: 20px 0 18px;
  }
  .process-dot__inner {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #fff;
    border: 3px solid var(--brand);
  }

  .process-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    position: relative;
  }

  .process-head {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 14px;
  }

  .process-num {
    position: relative;
    width: 56px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--brand);
    color: #fff;
    font-weight: 700;
    font-size: 18px;
    font-style: italic;
    letter-spacing: 0.5px;
    clip-path: polygon(0 0, 100% 0, 88% 100%, 0 100%);
  }
  .process-num span {
    transform: translateX(-2px);
  }

  .process-title {
    font-weight: 700;
    color: var(--ink);
    margin-bottom: 26px;
    letter-spacing: 1px;
    min-height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .process-circle {
    border-radius: 50%;
    border: 2px solid var(--brand);
    background: var(--brand-soft);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 2;
  }
  .process-circle__img {
    width: 90px;
    height: 90px;
    object-fit: contain;
  }

  .process-arrows {
    display: block;
    position: absolute;
    top: 220px;
    left: 0;
    right: 0;
    pointer-events: none;
    z-index: 1;
  }
  .process-arrow {
    position: absolute;
    top: 0;
    color: var(--brand);
    transform: translateY(-50%);
    opacity: 1;
  }
  .process-arrow:nth-child(1) {
    left: 23%;
  }
  .process-arrow:nth-child(2) {
    left: 48%;
  }
  .process-arrow:nth-child(3) {
    left: 74%;
  }

  .process-line {
    position: absolute;
    left: 0;
    right: 0;
    height: 0;
    max-width: 100%;
    margin: 0;
    z-index: 1;
  }
  .process-line__rail {
    position: absolute;
    top: 50%;
    left: 0;
    right: 26px;
    height: 3px;
    background: var(--brand-line);
    transform: translateY(-50%);
    border-radius: 2px;
  }

  .process-line__arrow {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--brand);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
  }

  /* 详情区域 */
  .process-detail {
    width: 90%;
    margin: 0 auto;
  }
  .process-detail__row {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--brand);
    font-weight: 600;
    font-size: 15px;
    margin-bottom: 6px;
  }
  .process-detail__row--mt {
    margin-top: 14px;
  }
  .process-detail__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--brand);
  }
  .process-detail__label {
    color: var(--brand);
    font-weight: 600;
  }
  .process-detail__time {
    color: var(--ink);
    line-height: 1.7;
  }
  .process-detail__content {
    color: var(--ink);
    line-height: 1.7;
  }
} /* end @media (min-width: 768px) */

/* ==================== 手机端时间线 ==================== */
@media (max-width: 767px) {
  .mobile-timeline {
    max-width: 600px;
    width: 92%;
    margin: 0 auto;
    padding-top: 10px;
  }

  /* 分组标题 */
  .mobile-group {
    margin-bottom: 32px;
  }
  .mobile-group:last-child {
    margin-bottom: 0;
  }
  .mobile-group__title {
    font-size: 22px;
    font-weight: 700;
    color: var(--brand);
    margin-bottom: 20px;
    padding-left: 2px;
  }

  /* 步骤容器：左侧竖线 + 右侧内容 */
  .mobile-steps {
    position: relative;
    padding-left: 0;
  }
  /* 竖线轨道 */
  .mobile-steps::before {
    content: '';
    position: absolute;
    left: 21px;
    top: 0;
    bottom: 0;
    width: 4px;
    background: var(--brand);
    border-radius: 2px;
    z-index: 0;
  }

  /* 每个步骤行：左侧编号+图标 | 右侧内容 */
  .mobile-step {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    margin-bottom: 24px;
    position: relative;
  }
  .mobile-step:last-child {
    margin-bottom: 0;
  }

  /* 左侧列：编号 + 图标 */
  .mobile-step__left {
    width: 45px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 1;
  }

  /* 编号圆点 */
  .mobile-step__num {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background: var(--brand);
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    font-style: normal;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 3px solid #fff;
    box-shadow: 0 0 0 2px var(--brand), 0 2px 8px rgba(241, 81, 8, 0.35);
    flex-shrink: 0;
  }
  .mobile-step__num span {
    transform: none;
  }

  /* 图标（编号下方） */
  .mobile-step__icon {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
    flex-shrink: 0;
    border: 2.5px solid var(--brand);
  }
  .mobile-step__icon img {
    width: 39px;
    height: 39px;
    object-fit: contain;
  }

  /* 右侧内容区 */
  .mobile-step__right {
    flex: 1;
    padding-left: 14px;
    min-width: 0;
  }

  /* 标题 */
  .mobile-step__title {
    font-size: 20px;
    font-weight: 700;
    color: var(--ink);
    line-height: 1.4;
    min-height: 45px;
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }

  /* 时间行 */
  .mobile-step__time-row {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 2px;
  }
  .mobile-step__label {
    display: inline-flex;
    align-items: center;
    color: var(--brand);
  }
  .mobile-step__label ::v-deep svg {
    width: 16px;
    height: 16px;
  }
  .mobile-step__label-text {
    font-size: 16px;
    font-weight: 600;
    color: var(--brand);
  }
  .mobile-step__time {
    font-size: 14px;
    color: var(--ink);
    line-height: 1.5;
    margin-bottom: 8px;
    padding-left: 22px;
  }

  /* 内容行 */
  .mobile-step__content-row {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 2px;
  }
  .mobile-step__content {
    font-size: 14px;
    color: var(--ink);
    line-height: 1.6;
    padding-left: 22px;
  }
}
/* ==================== 作品參考轮播 ==================== */
.works-swiper {
  padding: 10px 0 40px;
}
.works-swiper .swiper-slide {
  transition: transform 0.3s ease;
}
.works-swiper .swiper-slide-active .work-slide__img {
  transform: scale(1);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.work-slide {
  border-radius: 12px;
  overflow: hidden;
}
.work-slide__img {
  width: 100%;
  aspect-ratio: 3 / 4;
  object-fit: cover;
  border-radius: 12px;
  transform: scale(0.92);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
@media (min-width: 640px) {
  .work-slide__img {
    aspect-ratio: 4 / 3;
  }
}
@media (min-width: 1024px) {
  .works-swiper {
    padding: 10px 0 50px;
  }
  .work-slide__img {
    max-height: 420px;
  }
}

/* 自定义分页器样式 */
.swiper-pagination-works {
  text-align: center;
  margin-top: 8px;
}
.swiper-pagination-works .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  background: #ccc;
  opacity: 1;
  transition: all 0.3s;
}
.swiper-pagination-works .swiper-pagination-bullet-active {
  width: 24px;
  border-radius: 4px;
  background: var(--brand);
}
@media (min-width: 640px) {
  .swiper-pagination-works {
    margin-top: 16px;
  }
  .swiper-pagination-works .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
  }
  .swiper-pagination-works .swiper-pagination-bullet-active {
    width: 28px;
    border-radius: 5px;
  }
}

/* ==================== 榮譽評審嘉賓 ==================== */
.judges-grid {
  display: grid;
}
@media (min-width: 768px) {
  .judges-grid {
  }
}

.judge-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}
@media (min-width: 768px) {
  .judge-card {
    border-radius: 14px;
  }
}

.judge-card__avatar {
  width: 100%;
  aspect-ratio: 1 / 1;
  background: linear-gradient(135deg, #d5d5d5 0%, #b0b0b0 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.judge-card__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.judge-card__initials {
  font-size: 28px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: 2px;
  text-transform: uppercase;
}
@media (min-width: 768px) {
  .judge-card__initials {
    font-size: 36px;
  }
}

.judge-card__title {
  padding: 0 10px 14px;
}
@media (min-width: 768px) {
  .judge-card__title {
    padding: 0 14px 18px;
  }
}

/* ==================== 贊助夥伴 ==================== */
.sponsor-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.sponsor-item {
  width: calc(50% - 10px);
  max-width: 160px;
  aspect-ratio: 2 / 1;
  background: #fff;
  border-radius: 12px;
  padding: 16px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.sponsor-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}
.sponsor-item img {
  max-width: 100%;
  max-height: 60px;
  object-fit: contain;
}
@media (min-width: 768px) {
  .sponsor-grid {
    gap: 28px;
  }
  .sponsor-item {
    width: calc(25% - 21px);
    max-width: 200px;
    padding: 20px 16px;
    border-radius: 14px;
  }
  .sponsor-item img {
    max-height: 70px;
  }
}

/* ==================== 首次访问弹窗 ==================== */
.popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.popup-card {
  position: relative;
  background: #fff;
  border-radius: 16px;
  padding: 36px 28px 28px;
  width: 100%;
  max-width: 440px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.25);
}
.popup-card__close {
  position: absolute;
  top: 10px;
  right: 14px;
  background: none;
  border: none;
  font-size: 28px;
  color: #999;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  transition: color 0.2s;
}
.popup-card__close:hover {
  color: #333;
}
.popup-card__title {
  font-size: 22px;
  font-weight: 800;
  color: #f15108;
  text-align: center;
  line-height: 1.5;
  margin-bottom: 10px;
  padding-right: 20px;
}
.popup-card__subtitle {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}
.popup-card__section {
  background: #fafafa;
  border-radius: 10px;
  padding: 16px 18px;
  margin-bottom: 22px;
}
.popup-card__section-title {
  font-size: 16px;
  font-weight: 700;
  color: #222;
  margin-bottom: 12px;
}
.popup-card__info {
  font-size: 14px;
  color: #444;
  line-height: 1.7;
  margin-bottom: 4px;
}
.popup-card__label {
  font-weight: 600;
  color: #f15108;
}
.popup-card__note {
  font-size: 13px;
  color: #999;
  margin: 6px 0 8px;
  padding-left: 4px;
}
.popup-card__btn {
  display: block;
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #f15108, #f3700a);
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 1px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}
.popup-card__btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(241, 81, 8, 0.4);
}
@media (min-width: 768px) {
  .popup-card {
    padding: 44px 36px 36px;
    border-radius: 20px;
  }
  .popup-card__title {
    font-size: 25px;
  }
  .popup-card__subtitle {
    font-size: 17px;
  }
  .popup-card__section {
    padding: 20px 24px;
  }
  .popup-card__btn {
    padding: 16px;
    font-size: 20px;
  }
}
</style>
